/**
 * runtime: browser
 */
const { localStorage } = window;

export default {
  getItem: (key) => {
    if (!localStorage) return;
    const data = localStorage.getItem(key);
    if (data) {
      try {
        return JSON.parse(data);
      } catch (e) {
        console.log(e);
      }
    } else {
      return null;
    }
  },
  setItem: (key, data) => {
    if (!localStorage) return;
    try {
      return localStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      console.log('Sorry, the browser’s storage space is full.');
    }
  },
  removeItem: (key) => {
    if (!localStorage) return;
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.log(e);
    }
  },
};
